import React from "react";
import {
  Dialog,
  Typography,
  Button,
  Grid,
  DialogContent,
} from "@material-ui/core";

type Props = {
  isOpen: boolean;
  onConfirmClick: () => void;
  onCancelClick: () => void;
};

const DirectDepositWarningModal = ({
  isOpen,
  onConfirmClick,
  onCancelClick,
}: Props) => {
  const message =
    "Downloading this file assumes you will update Direct Deposit information for all listed users. Are you sure you want to proceed?";
  return (
    <Dialog maxWidth={"xs"} open={isOpen} onClose={onCancelClick}>
      <DialogContent>
        <Grid
          item
          container
          direction={"column"}
          spacing={2}
          justify={"center"}
          alignContent={"center"}
        >
          <Typography variant={"body2"} align={"center"}>
            {message}
          </Typography>
          <Grid item container direction={"row"} spacing={2} justify={"center"}>
            <Grid item>
              <Button
                variant={"contained"}
                color={"primary"}
                onClick={onConfirmClick}
              >
                Yes
              </Button>
            </Grid>
            <Grid item>
              <Button variant={"contained"} onClick={onCancelClick}>
                No
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default DirectDepositWarningModal;
